import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import axios from "axios";

import { connect } from "react-redux";


import Spinner from "../../common/Spinner";

//
import TextFieldGroup from "../../common/TextFieldGroup";
import TextFieldGroupPlain from "../../common/TextFieldGroupPlain";
import MapLookup from "../../common/MapLookup";

import SelectCategoryGroup from "../../common/SelectCategoryGroup";
//import ImageDisplay from "../common/ImageDisplay";
//import MapLookup from "../common/MapLookup";
import { modifyProperty, insertProperty } from "../../../actions/dealsActions";



class PropertyForm extends Component {
  constructor(props) {
    super(props);
    // console.log("props in advertisement", props);
    // console.log("id is", this.props.match.params.id);

    this.state = {
      which: "",
      _id: "",
      id: "",
      photo_path: "",
      name: "",
      company_id: "",
      description: "",
      thumbnail: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      latitude: "",
      longitude: "",
      region: "",
      country: "",
      url: "",
      stars: 3,
      //  status_flag: 0,
      isloading: true,


      errors: {}
    };

    //let posobj = { lat: 40.485, lng: -106.8317 };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.onFileInputChange = this.onFileInputChange.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
  }

  componentDidMount() {
    // if (this.props.auth.isAuthenticated) {
    //   this.props.history.push("/dashboard");
    // }

    //5be5fecd99d2840d0a58ea75
    this.loadState(this.props);

  }

  loadState = (props) => {

    this.setState(
      {
        which: props.property.which,
        _id: props.property._id,
        name: props.property.name,
        company_id: props.property.company_id,
        id: props.property.id,
        photo_path: props.property.photo_path,
        description: props.property.description,
        thumbnail: props.property.thumbnail,
        address: props.property.address,
        city: props.property.city,
        state: props.property.state,
        zip: props.property.zip,
        latitude: props.property.latitude,
        longitude: props.property.longitude,
        region: props.property.region,
        country: props.property.country,
        url: props.property.url,
        stars: props.property.stars,
        //  status_flag: props.property.status_flag,
        prop_lat: props.property.prop_lat,
        prop_lon: props.property.prop_lon
      }
    )

  }

  // if we have errors this will run
  // componentWillReceiveProps(nextProps) {
  //   //console.log("register componentWillReceiveProps");
  //   if (nextProps.errors) {
  //     this.setState({ errors: nextProps.errors });
  //   }
  // }
  // componentWillReceiveProps(nextProps) {
  //   //console.log("register componentWillReceiveProps");
  //   if (nextProps.errors) {
  //     this.setState({ errors: nextProps.errors });
  //   }
  //   if ((this.props.property.id) !== (nextProps.property.id)) {
  //     this.loadState(nextProps);
  //   }
  // }

  static getDerivedStateFromProps(props, state) {
    return {
      errors: props.errors
    };
  }

  componentDidUpdate(prevProps) {

    // if (this.props.property && ((this.props.property.id) !== (prevProps.property.id))) {
    //   this.loadState(this.props);
    // }

    if ((this.props.property.timemillis) !== (prevProps.property.timemillis)) {
      this.loadState(this.props);
    }

  }

  //prop['timemillis'] = Date.now();

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleMapClick(lat, lon) {
    let slat = lat.toString();
    let slon = lon.toString();
    this.setState({ latitude: lat, longitude: lon });
  }

  onFileInputChange(e) {
    // console.log(e.target.files[0]);
    if (e.target.files[0]) {
      //let fileurlobj = URL.createObjectURL(e.target.files[0]);
      this.setState({
        file: e.target.files[0],
        //fileurl: fileurlobj,
        statusmsg: ""
      });
    }
  }

  onSubmit(e) {
    e.preventDefault();

    // console.log(this.state);


    let formdata = new FormData();
    formdata.append("_id", this.state._id);
    formdata.append("id", this.state.id);
    formdata.append("photo_path", this.state.photo_path);
    formdata.append("name", this.state.name);
    formdata.append("company_id", this.state.company_id);
    formdata.append("description", this.state.description);
    formdata.append("thumbnail", this.state.thumbnail);
    formdata.append("address", this.state.address);
    formdata.append("city", this.state.city);
    formdata.append("state", this.state.state);
    formdata.append("zip", this.state.zip);
    formdata.append("latitude", this.state.latitude);
    formdata.append("longitude", this.state.longitude);
    formdata.append("region", this.state.region);
    formdata.append("country", this.state.country);
    formdata.append("url", this.state.url);
    formdata.append("stars", this.state.stars);
    //  formdata.append("status_flag", this.state.status_flag);

    if (this.state.which === 'modify') {
      this.props.modifyProperty(formdata, this.props.history);
    } else {
      this.props.insertProperty(formdata, this.props.history);
    }

  }

  // autocomplete methods

  //40.488231319769206
  //-106.83197827918531

  handleChange = name => {
    this.setState({ name });
    console.log("handleChange", name);
  };

  handleMapClick(lat, lon) {
    let slat = lat.toString();
    let slon = lon.toString();
    console.log(slat, slon);
    this.setState({ latitude: lat, longitude: lon });
  }

  render() {
    const { errors } = this.state;
    const perrors = this.props.errors;
    const latitude = this.state.latitude;
    const longitude = this.state.longitude;
    const { prop_lat } = this.state;
    const { prop_lon } = this.state;
    const { which } = this.state;
    //  console.log('status_flag', this.state.status_flag);
    // console.log(latitude, longitude);

    let selected_property = this.props.property;

    // if (this.state.isloading) {
    //   return <Spinner />;
    // }


    const searchOptions = {};

    let title = "Create";
    if (which === 'modify') {
      title = "Modify";
    }

    let hasimage = false;
    if (this.state.imageBuffer) {
      hasimage = true;
    }

    return (
      <div className="register">
        <div className="container">
          <div className="row">
            <div className="col-md-8 m-auto shadow-lg p-4">
              <p className=" text-center">{title} Property</p>

              <form noValidate onSubmit={this.onSubmit}>

                <div className="row">
                  <div className="col-md-2">
                    Name</div>

                  <div className="col-md-7">
                    <TextFieldGroupPlain
                      type="text"
                      label="name"
                      placeholder="name"
                      name="name"
                      value={this.state.name}
                      onChange={this.onChange}
                      error={errors.name}
                    />

                  </div>
                  <div className="col-md-1">
                    ID</div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="id"
                      placeholder="id"
                      name="id"
                      value={this.state.id}
                      onChange={this.onChange}
                      error={errors.id}
                    />

                  </div>
                </div>



                <div className="row">
                  <div className="col-md-2">
                    Description
                  </div>
                  <div className="col-md-10">
                    <TextFieldGroupPlain
                      type="text"
                      label="Description"
                      placeholder="Description"
                      name="description"
                      value={this.state.description}
                      onChange={this.onChange}
                      error={errors.description}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    Thumbnail
                  </div>
                  <div className="col-md-10">
                    <TextFieldGroupPlain
                      type="text"
                      label="thumbnail"
                      placeholder="thumbnail"
                      name="thumbnail"
                      value={this.state.thumbnail}
                      onChange={this.onChange}
                      error={errors.thumbnail}
                    />
                  </div>
                </div>






                <div className="row">
                  <div className="col-md-2">
                    Address
                  </div>
                  <div className="col-md-10">
                    <TextFieldGroupPlain
                      type="text"
                      label="Address"
                      placeholder="Address"
                      name="address"
                      value={this.state.address}
                      onChange={this.onChange}
                      error={errors.address}
                    />

                  </div>
                </div>



                <div className="row">
                  <div className="col-md-2">
                    city
                  </div>
                  <div className="col-md-4">
                    <TextFieldGroupPlain
                      type="text"
                      label="City"
                      placeholder="City"
                      name="city"
                      value={this.state.city}
                      onChange={this.onChange}
                      error={errors.city}
                    />

                  </div>
                  <div className="col-md-1">
                    state
                  </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="State"
                      placeholder="State"
                      name="state"
                      value={this.state.state}
                      onChange={this.onChange}
                      error={errors.state}
                    />

                  </div>
                  <div className="col-md-1">
                    zip
                  </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="Zip"
                      placeholder="Zip"
                      name="zip"
                      value={this.state.zip}
                      onChange={this.onChange}
                      error={errors.zip}
                    />

                  </div>
                </div>





                <div className="row">
                  <div className="col-md-2">
                    Region
                  </div>
                  <div className="col-md-4">
                    <TextFieldGroupPlain
                      type="text"
                      label="region"
                      placeholder="region"
                      name="region"
                      value={this.state.region}
                      onChange={this.onChange}
                      error={errors.region}
                    />

                  </div>
                  <div className="col-md-1">
                    Country
                  </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="country"
                      placeholder="country"
                      name="country"
                      value={this.state.country}
                      onChange={this.onChange}
                      error={errors.country}
                    />
                  </div>
                  <div className="col-md-1">
                    stars
                  </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="stars"
                      placeholder="stars"
                      name="stars"
                      value={this.state.stars}
                      onChange={this.onChange}
                      error={errors.stars}
                    />

                  </div>



                </div>

                <div className="row">
                  <div className="col-md-2">
                    Latitude
                  </div>
                  <div className="col-md-4">
                    <TextFieldGroupPlain
                      type="text"
                      label="Latitude"
                      placeholder="Latitude"
                      name="latitude"
                      value={this.state.latitude}
                      onChange={this.onChange}
                      error={errors.latitude}
                    />

                  </div>
                  <div className="col-md-2">
                    Longitude
                  </div>
                  <div className="col-md-4">
                    <TextFieldGroupPlain
                      type="text"
                      label="Longitude"
                      placeholder="Longitude"
                      name="longitude"
                      value={this.state.longitude}
                      onChange={this.onChange}
                      error={errors.longitude}
                    />

                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    URL
                  </div>
                  <div className="col-md-10">
                    <TextFieldGroupPlain
                      type="text"
                      label="url"
                      placeholder="url"
                      name="url"
                      value={this.state.url}
                      onChange={this.onChange}
                      error={errors.url}
                    />
                  </div>
                </div>















                <input type="submit" className="btn btn-info btn-block mt-4" />
              </form>
              <MapLookup
                handleMapClick={this.handleMapClick}
                lat={prop_lat}
                lon={prop_lon}
              />
              {perrors && (
                <div className="error-display">{perrors.message}</div>
              )}
              {/* <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-md-12">
                  <MapLookup
                    handleMapClick={this.handleMapClick}
                    lat={lat}
                    lon={lon}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div >
    );
  }
}

// this is good practice because it will help debugging
// it is not checked when in production mode.
// Business.propTypes = {
//   createBusiness: PropTypes.func.isRequired,
//   modifyBusiness: PropTypes.func.isRequired,
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired
// };

// map errors to this component
// then we can use this.props.auth.user etc
// since we mapped error, we can use componentWillReceiveProps method
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  deals: state.deals
});
// the state.auth above comes from rootReducer in index.js in reducers.

export default connect(
  mapStateToProps,
  { modifyProperty, insertProperty }
)(withRouter(PropertyForm));
// wrap the Register with withRouter so the authAction can use history to redirect



// WEBPACK FOOTER //
// ./src/components/deals/forms/PropertyForm.js